import React from 'react';
import ActivateAccount from '../../components/ActivateAccount/ActivateAccount';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';

const ActivateAccountPage: React.FC = () => {
	const params = useParams();
	return (
		<>
			<Header>{''}</Header>
			<ActivateAccount token={params.token} />
		</>
	);
};

export default ActivateAccountPage;
